module.exports = {
  "country": "IS",
  "artist": "Hera Björk",
  "song": "Je ne sais quoi",
  "year": "2010",
  "place": "19",
  "spotify": "5htZ21M2zhg3WLTib7YQ5r"
};